import React, { useEffect, useState } from 'react';
import { Button, Card, CardContent, Checkbox, CircularProgress, FormControlLabel, Typography } from '@material-ui/core';
import api from 'services/api';
import { getCodEmpresa } from 'lib/functions';

export default function ConfiguracaoGeralFinancas() {
  const [valor, setValor] = useState('N');
  const [carregando, setCarregando] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [falhou, setFalhou] = useState(false);
  const codempresa = getCodEmpresa() || 0;
  useEffect(() => {
    let ativo = true;
    api.get('/financas/configuracoes/geral', { params: { codempresa } })
      .then(({ data }) => { if (ativo) setValor(data.destacamovdebvermelho); })
      .catch((e) => { if (ativo) { setFalhou(true); setErro(e.response?.data?.error || 'Não foi possível carregar a configuração.'); } })
      .finally(() => { if (ativo) setCarregando(false); });
    return () => { ativo = false; };
  }, [codempresa]);
  const salvar = async () => {
    setSalvando(true); setErro(''); setMensagem('');
    try {
      await api.put('/financas/configuracoes/geral', { codempresa, destacamovdebvermelho: valor });
      setMensagem('Configuração salva com sucesso.');
    } catch (e) { setErro(e.response?.data?.error || 'Erro ao salvar configuração.'); }
    finally { setSalvando(false); }
  };
  return <div style={{ padding: 24, maxWidth: 900 }}>
    <Typography variant="h5">Configurações — Finanças</Typography>
    <Card style={{ marginTop: 16 }}><CardContent>
      <Typography variant="h6">Geral</Typography>
      {carregando ? <CircularProgress size={24} /> : <FormControlLabel
        control={<Checkbox color="primary" checked={valor === 'S'} disabled={salvando || falhou}
          onChange={(e) => { setValor(e.target.checked ? 'S' : 'N'); setMensagem(''); }} />}
        label="Destacar em vermelho no extrato de movimento débito em conta corrente" />}
      {erro && <Typography color="error">{erro}</Typography>}
      {mensagem && <Typography color="primary">{mensagem}</Typography>}
      <div style={{ marginTop: 20 }}><Button variant="contained" color="primary" onClick={salvar}
        disabled={carregando || salvando || falhou}>{salvando ? 'Salvando...' : 'Salvar'}</Button></div>
    </CardContent></Card>
  </div>;
}
